import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDischarge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 27,
	viewBox: "0 0 25 27",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			cx: 3.5,
			cy: 18.5,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			cx: 7.5,
			cy: 5.5,
			r: 5
		}),
		/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			cx: 19.5,
			cy: 21.5,
			r: 5
		}),
		/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			cx: 21.5,
			cy: 7.5,
			r: 3
		})
	]
});
export default SvgDischarge;
